//----------------------------------
//  PRIVATE CONSTANTS
//----------------------------------
const ALPHA = 'abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

//----------------------------------
//  PRIVATE PROPERTIES
//----------------------------------
let inc = null;

/**
 * Unique ID Generator
 * @author Sandro Ducceschi [eatcodyplay.ch, Switzerland]
 */
export default class UID {
  //---------------------------------------------------
  //
  //  API / Public Methods
  //
  //---------------------------------------------------

  /**
   * @name UID.getNumeric
   * Returns a incremental numerical unique Id (based (one-time) on the current timestamp)
   * @return {Number}
   */
  static getNumeric() {
    if (!inc) {
      inc = Math.floor(new Date().getTime());
    }
    inc += 1;
    return inc;
  }

  /**
   * @name UID.getLiteralFromNumeric
   * Returns a unique literal Id based on the incremental used by <code>UID.getNumeric</code>
   * @return {String|*}
   */
  static getLiteralFromNumeric() {
    if (!inc) {
      inc = Math.floor(new Date().getTime());
    }
    inc += 1;
    return inc.toString(36);
  }

  /**
   * @name UID.getAlphaId
   * Generates an alphanumeric id or decodes a alphanumeric string back to it's numeric parent
   * @param {Number|String} [value]
   */
  static getAlphaId(value) {
    let output = '';
    const bcpow = (a, b) => Math.floor(parseFloat(a) ** parseInt(b, 10));
    const microtime = (asFloat) => {
      const now = new Date().getTime() / 1000;
      const s = parseInt(now, 10);
      return (asFloat) ? now : `${Math.round((now - s) * 1000) / 1000} ${s}`;
    };

    if (typeof value === 'undefined' || typeof value === 'number') {
      if (typeof value === 'undefined') {
        // eslint-disable-next-line no-param-reassign
        value = microtime(true) * 10000;
      }

      for (let i = Math.floor(Math.log(parseInt(value, 10)) / Math.log(ALPHA.length)); i >= 0; i -= 1) {
        output += ALPHA.substr((Math.floor(parseInt(value, 10) / bcpow(ALPHA.length, i)) % ALPHA.length), 1);
      }
    } else if (typeof value === 'string') {
      output = 0;
      for (let i = 0; i <= (value.length - 1); i += 1) {
        output += ALPHA.indexOf(value.substr(i, 1)) * (bcpow(ALPHA.length, (value.length - 1) - i));
      }
    }
    return output;
  }
}
